import _Object$keys from "@babel/runtime-corejs2/core-js/object/keys";
import dayjs from 'dayjs';

var togglePanel = function togglePanel(list, type) {
  _Object$keys(list).forEach(function (key) {
    list[key] = false;
  });

  list[type] = true;
  return list;
};

var generateTime = function generateTime(time) {
  var i = 0;
  var arr = [];

  while (i <= time) {
    var unit = i < 10 ? "0".concat(i) : "".concat(i);
    arr.push(unit);
    i += 1;
  }

  return arr;
};

var getTimeValue = function getTimeValue(type, date, format) {
  var result = '';

  switch (type) {
    case 'timestamp':
      result = date && date.valueOf();
      break;

    case 'string':
      result = date && date.format(format);
      break;

    case 'second':
      result = Math.floor((date && date.valueOf()) / 1000);
      break;

    default:
      break;
  }

  return result;
};

var dayjsObject = function dayjsObject(value) {
  if (value === '' || value === null || value === undefined) {
    return '';
  }

  if (typeof value === 'string' || typeof value === 'number') {
    return dayjs(value);
  }

  return value;
};
/**
 * DateFormatter
 */


var dateFormatter = function dateFormatter(date, format, raw) {
  if (format === 'second') {
    if (typeof +date === 'number') {
      date *= 1000;
    } else {
      console.warn('type 为 second 时，只支持 number 类型');
    }
  }

  if (raw) {
    return date || '';
  }

  return date ? dayjsObject(date) : '';
};

var contains = function contains(root, n) {
  var open = this.state.open;
  var current = this.inputNode.current;

  if (this.fold && open) {
    this.fold = false;
    return false;
  }

  return !open && current && current.contains(n) || root && root.contains(n);
};

var onOpenChange = function onOpenChange(evt) {
  evt.stopPropagation();
  var current = this.rootNode.current;
  var open = contains.call(this, current, evt.target);
  this.setState({
    open: open
  });
};

var mouseEnter = function mouseEnter() {
  this.setState({
    closeShow: true
  });
};

var mouseLeave = function mouseLeave() {
  this.setState({
    closeShow: false
  });
};

export { togglePanel, generateTime, getTimeValue, onOpenChange, contains, mouseEnter, mouseLeave, dayjsObject, dateFormatter };